<template>
  <div>
    <vue-recaptcha
      v-if="!isHiddenRECAPTCHA"
      ref="recaptcha"
      size="invisible"
      :sitekey="secretKeyRECAPTCHA"
      @verify="verify"
      @render="validateRECAPTCHA"
      badge="bottomleft"
    ></vue-recaptcha>
    <Layout v-if="isShowLayout" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { VueRecaptcha } from 'vue-recaptcha';
import { typesApp } from '@/store/app/typesModuleApp';

const { ENV_SECRET_KEY_RECAPTCHA, ENV_IS_HIDDEN_RECAPTCHA } = global.conf;

export default {
  name: 'App',

  components: {
    VueRecaptcha,
    Layout: () => import('./components/Main/Layout.vue'),
  },

  data() {
    return {
      secretKeyRECAPTCHA: ENV_SECRET_KEY_RECAPTCHA,
      isHiddenRECAPTCHA: ENV_IS_HIDDEN_RECAPTCHA,
    };
  },

  computed: {
    ...mapGetters({
      getRecaptchaId: `${typesApp.PATH}/${typesApp.getters.GET_RECAPTCHA_ID}`,
    }),
    isShowLayout() {
      return this.getRecaptchaId || this.isHiddenRECAPTCHA;
    },
  },

  methods: {
    ...mapActions({
      updateRecaptchaId: `${typesApp.PATH}/${typesApp.actions.UPDATE_RECAPTCHA_ID}`,
    }),
    verify(response) {
      this.updateRecaptchaId(response);
    },
    async validateRECAPTCHA() {
      await this.$refs.recaptcha.reset();
      await this.$refs.recaptcha.execute();
    },
  },
};
</script>

<style lang="scss">
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
